<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer007">
<p class="basic-paragraph"><span class="charoverride3"><br class="calibre1"/></span></p>
<h1 class="basic-paragraph"><span class="charoverride3">Epigraph</span></h1>
<p class="basic-paragraph"><span class="charoverride1"><br class="calibre2"/></span></p>
<p class="basic-paragraph"><span class="charoverride1">“Observe constantly that all things take place by change, <br/>and accustom thyself to consider that<br/>the nature of the universe loves nothing so much as<br/>to change the things which are,<br/>and make new things like them.”</span></p>
<p class="basic-paragraph2"><span class="charoverride2">—Marcus Aurelius</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?b9299256